import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField } from '@mui/material';
import type { Schema } from '../../services/api';
import { statusOptions, statusLabels } from './types';

interface CloneSchemaSetDialogProps {
  open: boolean;
  schema: Schema | null | undefined;
  /** @deprecated Use schema instead */
  schemaSet?: Schema | null | undefined;
  onClose: () => void;
  cloneForm: { name: string; status: string; createdBy: string };
  onFormChange: React.Dispatch<React.SetStateAction<{ name: string; status: string; createdBy: string }>>;
  onSubmit: () => void;
  isLoading: boolean;
}

const CloneSchemaSetDialog: React.FC<CloneSchemaSetDialogProps> = ({
  open,
  onClose,
  cloneForm,
  onFormChange,
  onSubmit,
  isLoading,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>Clone Schema</DialogTitle>
    <DialogContent dividers>
      <Stack spacing={2}>
        <TextField
          label="New Name"
          fullWidth
          required
          value={cloneForm.name}
          onChange={(event) => onFormChange((prev) => ({ ...prev, name: event.target.value }))}
          size="small"
        />
        <TextField
          label="Status"
          fullWidth
          select
          value={cloneForm.status}
          onChange={(event) => onFormChange((prev) => ({ ...prev, status: event.target.value }))}
          size="small"
        >
          {statusOptions.map((status) => (
            <MenuItem key={status} value={status}>
              {statusLabels[status] ?? status}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onSubmit} variant="contained" disabled={isLoading || !cloneForm.name.trim()}>
        {isLoading ? 'Cloning...' : 'Clone'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default CloneSchemaSetDialog;
